import React from 'react'

import { Dialog, useDialogState } from '../../../main/components/dialog'
import { Spinner } from '../../../main/components/spinner'
import { useAsyncModule } from '../../../main/services/async-modules-utils'
import { decodeQueryString } from '../../queryString'
import { createAlertAsyncModule } from '../create-alert/async-modules'

type CreateAlertLinkProps = {
  index: number
}

export default function CreateAlertLink({ index }: CreateAlertLinkProps) {
  const { t } = decodeQueryString()
  const urlTicker = t.split(',')[index]
  const dialog = useDialogState()
  const isVisible = dialog.useState('open')

  const [createAlertModule] = useAsyncModule({
    ...createAlertAsyncModule,
    shouldLoadModule: isVisible,
  })
  const CreateAlert = createAlertModule?.CreateAlert

  return (
    <>
      <span
        onClick={(e) => {
          e.preventDefault() // needed to prevent opening parent link
          window.gtag?.('event', 'click', { event_category: 'create-alert' })
          dialog.show()
        }}
      >
        Create Alert
      </span>
      <Dialog state={dialog} aria-label="Create Alert" className="w-[366px]">
        {CreateAlert ? (
          <CreateAlert ticker={urlTicker} />
        ) : (
          <div className="flex h-96 items-center justify-center">
            <Spinner />
          </div>
        )}
      </Dialog>
    </>
  )
}
